<template>
  <div class="field is-grouped is-grouped-centered">
    <v-col cols="12" sm="6">
      <div class="field">
        <label class="label">Equipos</label>
        <v-combobox
          v-model="equipoSeleccionado"
          :items="nombres"
          :search-input.sync="search"
          item-text="nombre"
          item-value="id"
          label="Selecciona tu equipo preferido o crea uno equipo nuevo"
          small-chips
          :rules="[rules.required]"
          @change="crearEquipo"
          color="green"
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-content>
                <span class="icon is-small is-left">
                  <i class="material-icons">&#xe147;</i>
                </span>
                <v-list-item-title>
                  Desea crear el equipo: "
                  <strong>{{ search }}</strong>". Presiona
                  <kbd>ENTER</kbd> para crearlo.
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-combobox>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import { nombresEquipos } from "../api";

export default {
  data: function () {
    return {
      name: "reto-comp",
      nombres: [],
      equipoSeleccionado: null,
      equipoEnviar: {
        id: null,
        clave: null,
        name: null,
      },
      disabled: true,
      search: null,
      rules: {
        required: (value) => !!value || "Obligatorio",
      },
    };
  },
  computed: {},
  methods: {
    fetchNombresEquipos() {
      //this.consultando = true;
      axios
        .get(nombresEquipos)
        .then((response) => {
          this.nombres = response.data.results;
        })
        .catch((error) => {
          console.log("Error");
          console.log(error);
        })
        .then(() => {
          //this.consultando = false;
        });
    },
    crearEquipo() {
      /*método para identificar si el usuario seleccionó un equipo de la lista 
      o va a crear uno crearEquipo*/

      // cuando el equipo no esta en la lista, "equipoSeleccionado" se convierte en un string
      if (
        typeof this.equipoSeleccionado == "string" &&
        this.equipoSeleccionado != null
      ) {
        (this.equipoEnviar.id = "0"),
          (this.equipoEnviar.clave = false),
          (this.equipoEnviar.name = this.search);
      }
      // cuando selecciona un equipo de la lista, "equipoSeleccionado" se convierte en un objeto
      else if (
        typeof this.equipoSeleccionado == "object" &&
        this.equipoSeleccionado != null
      ) {
        (this.equipoEnviar.id = this.equipoSeleccionado.id),
          (this.equipoEnviar.clave = true),
          (this.equipoEnviar.name = this.equipoSeleccionado.name);
      }
      this.$store.commit("setNombreEquipo", this.equipoEnviar);
    },
  },

  mounted() {
    this.fetchNombresEquipos();
  },
};
</script>

<style lang="scss" >
</style>